import * as RadixSlider from '@radix-ui/react-slider';
import { cn } from '@/lib/utils';

export interface SliderProps extends RadixSlider.SliderProps {
  className?: string;
}

export function Slider({ className, ...props }: SliderProps) {
  return (
    <RadixSlider.Root
      className={cn('relative flex w-full touch-none select-none items-center', className)}
      {...props}
    >
      <RadixSlider.Track className="relative h-px w-full grow overflow-hidden bg-border">
        <RadixSlider.Range className="absolute h-full bg-accent" />
      </RadixSlider.Track>
      <RadixSlider.Thumb className="block h-3.5 w-3.5 rounded-full border border-accent bg-bg-surface shadow-card transition-colors focus:outline-none focus-visible:ring-1 focus-visible:ring-accent focus-visible:ring-offset-1 focus-visible:ring-offset-bg-base" />
    </RadixSlider.Root>
  );
}
